import dotenv from 'dotenv';
dotenv.config();
export default class ConfigProvider {
  static get CONFIG() {
    return {
      apiFrontend: '$VUE_APP_API_FRONTEND',
      apiBackend: '$VUE_APP_API_BACKEND',
      apiUrl: '$VUE_APP_API',
      authUrl: '$VUE_APP_API_AUTH',
      tenant: '$VUE_APP_TENANT',
      client: '$VUE_APP_CLIENT'
    };
  }
  static value(name) {
    if (!(name in this.CONFIG)) {
      return;
    }
    const value = this.CONFIG[name];
    if (!value) {
      return;
    }
    if (value.startsWith('$VUE_APP_')) {
      const envName = value.substr(1);
      const envValue = process.env[envName];
      if (envValue) {
        return envValue;
      }
      else {
        return;
      }
    }
    else {
      return value;
    }
  }
}